export const MACHINERY_SUB_CATEGORY_TAGS = {
    SUB_CATEGORY_LIST: "getSubCategoryList",
    SUB_CATEGORY_BY_ID: "getSubCategoryById",
} as const;